<app-loading *ngIf="!error; else elseBlock" [isLoading]="isLoading">
  <div class="layout">
    <app-header
      *ngIf="appReady"
      class="app-header"
      [avatar]="avatarName"
      (toggleMenu)="toggleMenu()"
      [currentRoute]="currentRoute"
    >
      Acciona
    </app-header>
    <app-menu *ngIf="appReady" class="app-menu" [isOpen]="isMenuOpen"></app-menu>
    <main #main [ngClass]="{ 'full-screen-route': isFullScreenRoute }">
      <router-outlet></router-outlet>
    </main>
    <app-footer class="app-footer"></app-footer>
  </div>
</app-loading>

<ng-template #elseBlock>
  <div class="error">
    <div>
      <img [src]="'/assets/images/error-robot.svg'" alt="filter" />
    </div>
    <div class="message">
      <img [src]="'/assets/icons/logo.svg'" alt="filter" />
      <span class="bold">
        {{ 'COMMONS.ERROR_APP.ERROR_1' | i18nextEager }}
      </span>
      <span>{{ 'COMMONS.ERROR_APP.ERROR_2' | i18nextEager }}</span>
      <span>{{ 'COMMONS.ERROR_APP.ERROR_3' | i18nextEager }}</span>
      <span>{{ 'COMMONS.ERROR_APP.ERROR_4' | i18nextEager }}</span>
      <span>{{ 'COMMONS.ERROR_APP.ERROR_5' | i18nextEager }}</span>
      <span>{{ 'COMMONS.ERROR_APP.ERROR_6' | i18nextEager }}</span>
      <a href="mailto:atencioncanal@acciona.com">atencioncanal@acciona.com</a>
      <button class="bold" mat-flat-button color="accent" (click)="retry()">
        {{ 'COMMONS.RETRY' | i18nextEager }}
      </button>
    </div>
  </div>
</ng-template>
